/** match any alphanumeric, - and _ between {{ }} */
export const tagFinderRegex = '(?:{{)([a-zA-Z0-9-_]*?)(?=}})';

/** hard limit for tags usage within an email so we don't delay email sending */
export const PERSONALIZATION_TAGS_MAX_COUNT = 100;
